/* eslint-disable @next/next/no-img-element */

"use client";

import Image from "next/image"
import { buttonVariants } from "@/components/fun-ui/Button";
import { useEffect, useState, Fragment, useMemo } from "react";
import { useGlobalConfig } from "@/stores/appStore";
import Link from "next/link";
import { cn } from "@/lib/utils";
import Loading from "@/components/Loading";


// const featuresData = {
//   "title": "Findin AI 文献综述",
//   "subtitle": "全学科都擅长，更专业",
//   "url": "https://oss.findinai.cn/storage/20241107/714935077c330784aa231897f4595d95.png",
//   features: [{
//     caption: "表格式文献管理",
//     url: "https://oss.findinai.cn/storage/20241107/67d9927ff48e93f6d74ead5e5add12dd.png"
//   }, {
//     caption: "表格式文献管理",
//     url: "https://oss.findinai.cn/storage/20241107/776d4976d4db154d54ad977200357483.png"
//   }, {
//     caption: "文献摘录与笔记",
//     url: "https://oss.findinai.cn/storage/20241107/eb0135a5143c599706556b74d7d3a63b.png"
//   }, {
//     caption: "大纲笔记与思维导图",
//     url: "https://oss.findinai.cn/storage/20241107/86b8a6fc4a3225d9ceb7b1598058ceeb.png"
//   }, {
//     caption: "大纲笔记与思维导图",
//     url: "https://oss.findinai.cn/storage/20241107/30a4bdba95275947a8640a3172daa063.png"
//   }]
// };

export function LiteratureReview() {
  const {
    value: globalConfig,
    fetch: fetchGlobalConfig,
  } = useGlobalConfig().globalConfig;

  const featuresData = useMemo(() => {
    return globalConfig?.pc.literatureReview;
  }, [globalConfig]);

  useEffect(() => {
    fetchGlobalConfig();
  }, [fetchGlobalConfig]);

  const [cookieHasNickname, setCookieHasNickname] = useState(true);
  useEffect(() => {
    setCookieHasNickname(document.cookie.indexOf('nickname') !== -1);
  }, []);

  if (!featuresData) {
    return (
      <div className="h-screen w-screen relative">
        <Loading size="lg" className="-mt-20"></Loading>
      </div>
    )
  }
  return (
    <div
      className="flex flex-1 relative flex-col overflow-hidden bg-[#EDEFF4]"
    >
      <div className="pt-6 pb-14 bg-background">
        <div className="container flex flex-row justify-between items-center px-0">
          <div className="flex flex-col justify-center min-w-[680px] h-[407px] px-4 pt-7">
            <h2 className="text-[54px] text-foreground font-semibold">{featuresData.title}</h2>
            <div className="text-[#3D3D3D] text-xl">{featuresData.subtitle}</div>
            <Link
              href={cookieHasNickname ? "/summarizes" : "/login"}
              replace={false}
              className={cn(
                buttonVariants({ variant: 'default' }),
                "cursor-pointer",
                "w-[210px] h-[52px] rounded-full mt-16 text-[18px] font-medium"
              )}
            >立即开始</Link>
          </div>
          <Image className="pointer-events-none px-4" alt={featuresData.title} src={featuresData.url} width={453} height={407} />
        </div>
      </div>
      <div className="container mx-auto min-h-screen" id="content">
        <div className="-mx-[759px] w-[2604px]">
          {
            featuresData?.features.map((feature) => (
              <Fragment
                key={feature.url}
              >
                <img
                  src={feature.url}
                  alt={feature.title}
                  width={2604}
                />
                <div className="sr-only">
                  <h2>{feature.title}</h2>
                  {
                    feature.caption.split('/n').map((str, index) => {
                      return <p key={index}>{str}</p>
                    })
                  }
                </div>
              </Fragment>
            ))
          }
        </div>
      </div>
      <div className="container mx-auto flex justify-center">
        <Link
          href={cookieHasNickname ? "/summarizes" : "/login"}
          replace={false}
          className={cn(
            buttonVariants({ variant: 'default' }),
            "cursor-pointer",
            "w-[310px] h-[52px] rounded-full mb-24 text-[18px] font-medium"
          )}
        >立即开始</Link>
      </div>
    </div >
  )
}
